import { ApiClient } from 'ApiClient';
import { SetMenu } from 'interfaces';

class SetMenuService {
  public async get() {
    const response = await ApiClient.get<SetMenu[]>('set-menus');

    return response as SetMenu[];
  }

  public save({ id, data }: { id?: number; data: any }) {
    if (id) {
      return ApiClient.post(`set-menus/update/${id}`, data);
    }

    return ApiClient.post('set-menus', data);
  }

  public delete(id: number) {
    return ApiClient.delete(`set-menus/${id}`);
  }
}

const singleton = new SetMenuService();

export { singleton as SetMenuService };
